/**
 * Variáveis de contexto disponíveis no fluxo do ChatBot (compatível com Xpro legado).
 * Usar na resposta com $nome (ex.: $nomecliente). São substituídas pelo valor no momento do envio.
 */
export const VARIAVEIS_CONTEXTO = [
  { name: "$resposta", label: "Resposta acumulada", group: "fluxo" },
  { name: "$mensagem", label: "Última mensagem do usuário", group: "fluxo" },
  { name: "$protocolo", label: "Protocolo / ID da solicitação", group: "sistema" },
  { name: "$nomecliente", label: "Nome do cliente", group: "cliente" },
  { name: "$nomeclientevalido", label: "Nome do cliente (validado)", group: "cliente" },
  { name: "$emailcliente", label: "E-mail do cliente", group: "cliente" },
  { name: "$telefonecliente", label: "Telefone do cliente", group: "cliente" },
  { name: "$celularcliente", label: "Celular do cliente", group: "cliente" },
  { name: "$operador", label: "Nome do operador", group: "sistema" },
  { name: "$pontuacao", label: "Pontuação", group: "sistema" },
  { name: "$tagscliente", label: "Tags do cliente", group: "cliente" },
  { name: "$tags", label: "Tags", group: "sistema" },
  { name: "$datacompleta", label: "Data completa", group: "data" },
  { name: "$data", label: "Data", group: "data" },
  { name: "$dia", label: "Dia", group: "data" },
  { name: "$mes", label: "Mês", group: "data" },
  { name: "$ano", label: "Ano", group: "data" },
  { name: "$horacompleta", label: "Hora completa", group: "data" },
  { name: "$hora", label: "Hora", group: "data" },
  { name: "$minuto", label: "Minuto", group: "data" },
  { name: "$segundo", label: "Segundo", group: "data" },
  { name: "$diasemana", label: "Dia da semana", group: "data" },
  { name: "$datadigitada", label: "Data digitada (pelo usuário no fluxo)", group: "fluxo" },
  { name: "$origem", label: "Origem", group: "fluxo" },
  { name: "$retornoviagem", label: "Retorno viagem", group: "fluxo" },
  { name: "$resultadoconsultahorarios", label: "Resultado consulta horários", group: "fluxo" },
  { name: "$erroconsultahorarios", label: "Erro consulta horários", group: "fluxo" },
  { name: "$opcaoreserva", label: "Opção reserva", group: "fluxo" },
  { name: "$resultadoconsultaopcaoselecionada", label: "Resultado opção selecionada", group: "fluxo" },
  { name: "$resultadoconsultaassentos", label: "Resultado consulta assentos", group: "fluxo" },
  { name: "$erroconsultaassentos", label: "Erro consulta assentos", group: "fluxo" },
  { name: "$assentoselecionado", label: "Assento selecionado", group: "fluxo" },
  { name: "$nomepassageiro", label: "Nome do passageiro", group: "fluxo" },
  { name: "$documentopassageiro", label: "Documento do passageiro", group: "fluxo" },
  { name: "$id_transacao", label: "ID da transação", group: "sistema" },
  { name: "$qrcodepixreserva", label: "QR Code PIX reserva", group: "sistema" },
];

/** Agrupa por group para exibição */
const GROUPS = {
  fluxo: "Fluxo / conversa",
  sistema: "Sistema",
  cliente: "Cliente",
  data: "Data e hora",
  outros: "Outras",
};

export function getVariablesByGroup() {
  const byGroup = {};
  VARIAVEIS_CONTEXTO.forEach((v) => {
    const g = v.group || "outros";
    if (!byGroup[g]) byGroup[g] = [];
    byGroup[g].push(v);
  });
  return { byGroup, groupLabels: GROUPS };
}
